document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('location-popup');
  if (!popup) return;

  const store = localStorage.getItem('store_name');
  const time = Number(localStorage.getItem('store_name_time'));
const FALLBACK_TIMEOUT = 10 * 1000;
  if (store && time && (Date.now() - time < EXPIRY)) {
    return;
  }

  document.documentElement.classList.add('location-popup-active');
  document.body.classList.add('location-popup-active');

  popup.classList.remove('hidden');

  initPopup();
});

function initPopup() {
  const dropdown = document.getElementById('location-dropdown');
  const selected = document.getElementById('dropdown-selected');
  const items = document.querySelectorAll('.dropdown__item');
  const info = document.getElementById('location-info');
  const helperText = document.getElementById('location-helper');
  const confirmBtn = document.getElementById('location-confirm');

  let selectedStore = null;
  const isArabic = document.documentElement.lang.includes('ar');

  selected.addEventListener('click', () => {
    dropdown.classList.toggle('open');
  });

  items.forEach(item => {
    item.addEventListener('click', () => {
      selectedStore = item.dataset.store;

      selected.innerText = item.innerText.trim();
      dropdown.classList.remove('open');

      helperText.innerText = "";

      info.innerText = isArabic
        ? `طلبك سيصل اليك من ${selectedStore}`
        : `Your order will be delivered from ${selectedStore}`;
    });
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });

  confirmBtn.addEventListener('click', function () {
    if (!selectedStore) {
      alert(isArabic ? 'يرجى اختيار صيدلية' : 'Please select pharmacy');
      return;
    }

    localStorage.setItem('store_name', selectedStore);
    localStorage.setItem('store_name_time', Date.now());

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          store_name: selectedStore
        }
      })
    });

    document.documentElement.classList.remove('location-popup-active');
    document.body.classList.remove('location-popup-active');
    document.getElementById('location-popup').classList.add('hidden');
  });

  autoSelectNearestStore(items, selected, info, helperText, isArabic, (store) => {
    selectedStore = store;
  });
}

function autoSelectNearestStore(items, selected, info, helperText, isArabic, setStore) {
  if (!navigator.geolocation) {
    helperText.innerText = isArabic
      ? "* اختر الصيدلية الأقرب لك"
      : "* Choose your nearest pharmacy";
    return;
  }

    helperText.innerText = isArabic
    ? "* جاري تحديد أقرب صيدلية..."
    : "* Detecting nearest pharmacy...";

  navigator.geolocation.getCurrentPosition(
    (position) => {
      const userLat = position.coords.latitude;
      const userLng = position.coords.longitude;

      let nearestItem = null;
      let shortestDistance = Infinity;

      items.forEach(item => {
        const lat = parseFloat(item.dataset.lat);
        const lng = parseFloat(item.dataset.lng);

        if (!lat || !lng) return;

        const distance = getDistance(userLat, userLng, lat, lng);

//         console.log("STORE:", item.dataset.store);
// console.log("LAT LNG:", lat, lng);
// console.log("DISTANCE:", distance);

        if (distance < shortestDistance) {
          shortestDistance = distance;
          nearestItem = item;
        }
      });

      if (nearestItem) {
        const storeName = nearestItem.dataset.store;

        selected.innerText = nearestItem.innerText.trim();
        setStore(storeName);

        info.innerText = isArabic
          ? `طلبك سيصل اليك من ${storeName}`
          : `Your order will be delivered from ${storeName}`;

        helperText.innerText = isArabic
          ? "* أقرب صيدلية لموقعك"
          : "* Nearest pharmacy to your location";
      }
    },
    () => {
      helperText.innerText = isArabic
        ? "* اختر الصيدلية الأقرب لك"
        : "* Choose your nearest pharmacy";
    },
    {
      enableHighAccuracy: false
    }
  );
}

function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;

  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;

  const a =
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI/180) *
    Math.cos(lat2 * Math.PI/180) *
    Math.sin(dLon/2) *
    Math.sin(dLon/2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}